import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Paper, Typography, Chip, Avatar } from '@mui/material';
import { FilterAlt as ConditionIcon } from '@mui/icons-material';

const ConditionNode = ({ data, selected }) => {
  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: '12px 16px',
        borderRadius: 2,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : '#ff9800',
        backgroundColor: selected ? 'primary.light' : '#fff3e0',
        minWidth: 180,
        transition: 'all 0.2s'
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{
          background: '#ff9800',
          width: 10,
          height: 10
        }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Avatar
          sx={{
            width: 28,
            height: 28,
            backgroundColor: '#ff9800',
            color: 'white'
          }}
        >
          <ConditionIcon fontSize="small" />
        </Avatar>
        <Typography variant="caption" sx={{ color: '#ff9800', fontWeight: 600 }}>
          CONDITION
        </Typography>
      </Box>
      
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
        {data.label || 'If Condition'}
      </Typography>
      
      {data.config?.field && data.config?.operator && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {data.config.field} {data.config.operator} {data.config.value}
        </Typography>
      )}
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Handle
          type="source"
          position={Position.Bottom}
          id="true"
          style={{
            left: '30%',
            background: '#4caf50',
            width: 10,
            height: 10
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          id="false"
          style={{
            left: '70%',
            background: '#f44336',
            width: 10,
            height: 10
          }}
        />
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
        <Typography variant="caption" sx={{ color: '#4caf50' }}>True</Typography>
        <Typography variant="caption" sx={{ color: '#f44336' }}>False</Typography>
      </Box>
    </Paper>
  );
};

export default memo(ConditionNode);